export const shouldLoadPolyfill = () => typeof jest !== 'undefined' || typeof window === 'undefined';
//# sourceMappingURL=should-laod-polyfill.js.map